// _Timeline.scss
"use strict";
	
jQuery(document).ready(function() {
	const components = document.querySelectorAll('.cmp-flindersonline-timeline');
	var isMobile = window.innerWidth < 992;	
	const heightDefault = 300; 
	var height = heightDefault;	

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
    		const target = entry.target;

			if (entry.isIntersecting) {
				target.setAttribute('isVisible', true);
				const isVisible = true;
				const isLoaded = target.dataset.isLoaded;

				if(!isLoaded && isVisible){
					animateTimeline(target);
				}
			}
		});
	}, {
		threshold: 0.1 
	});

	if (components.length > 0) {
		components.forEach(component => {
			const total_width = component.clientWidth;
			const timeline = component.querySelector('.timeline');
			const divider = component.querySelector('.timeline__divider');
			const timelinecards = component.querySelectorAll('.timeline__card');
			const titles = Array.from(document.querySelectorAll('.timeline__title') || []);
			const isAuthor = component.dataset.author === 'true';
			component.setAttribute('isLoaded', false);
			component.setAttribute('isVisible', false)

			if(!isAuthor){
				if(timelinecards && timelinecards.length){
					setTimelineCards(component, total_width, divider, timelinecards);			
					observer.observe(component);
				}else{
					timeline.style.height = 'auto';
					timeline.style.display = 'none';
				}
			}

			//Titles need to be 8 or less characters
			titles?.forEach(title => {
				var text = title?.querySelector('.text');
				if (text?.textContent?.length > 8) {
				text.textContent = text.textContent.substring(0, 8);
				}
			})
		});
	}

	function setTimelineCards(component, total_width, divider, timelinecards){
		const title_width = total_width / timelinecards.length;
		const isLoaded = component.dataset.isLoaded;
		const isVisible = component.dataset.isVisible;

		requestAnimationFrame(() => {
			const timeline = component.querySelector('.timeline');
			const highlight = component.querySelector('.marker_highlight');
			highlight.style.opacity = 0;
			divider.style.opacity = 0;
			height = 0;

			//Visually equalize spacing of Timeline Cards For (Cards > 3 & < 9)
			//Edge cards (First and Last) will have lesser width
			//Middle cards equally distributed
			const n = timelinecards.length;
			const P_outer = 100 / (n - 1); 
			const eachOuter = P_outer / 2; // First and Last
			const middleCount = n - 2;
			const P_middle = 100 - P_outer;
			const eachMiddle = P_middle / middleCount; // Middle Cards

			timelinecards.forEach((card, i) => {
				const content = card.querySelector('.timeline__content');
				const rte = content.querySelector('.rte');
				if (rte) height += rte.clientHeight;
				
				if(!isMobile){
					//set dynamic width of timeline card content
					//make sure it doesnt exceed 100%
					//For desktop its 50% of the timeline width to mitigate collission of contents
					content.style.width = (total_width / 2) + 'px';

					//equalize distribution of markers visually
					//manual update of card width
					if(n > 3 && n < 10){
						const isEdge = i === 0 || i === n - 1;
						const width = isEdge ? eachOuter : eachMiddle;
						card.style.width = width + '%';
					}
				}
			});

			const finalHeight = height; 
			component.style.height = (isMobile ? 'auto' : (finalHeight + 100) + 'px');
			divider.style.height = (isMobile ? 'auto' : '1px');

			timelinecards.forEach((card, index) => {
				card.style.height = (isMobile ? 'auto' : finalHeight + 'px');

				const title = card.querySelector('.timeline__title');
				const content = card.querySelector('.timeline__content');
				const rte = content.querySelector('.rte');
				const connector = card.querySelector('.timeline__line');

				card.setAttribute('data-cardid', 'card'+index);
				title.setAttribute('data-width', title_width)

				if(rte.innerHTML.trim()){
					card.classList.add('hasContent');
				}

				if(!isMobile){
					highlight.style.transition = 'none';
					card.style.setProperty('width', 'unset');
					content.style.setProperty('position', 'absolute');
					highlight.style.top = '-7.5px';
					title.style.setProperty('width', title_width + 'px');					
					connector.style.height = 40 + (rte.getBoundingClientRect().top - content.getBoundingClientRect().top) + 'px';
					clampCenteredContent(timeline, content);
					highlight.style.transition = 'all 1s ease';
				}else{
					title.style.setProperty('width', 'auto');
					card.style.setProperty('width', '100%');
					content.style.setProperty('position', 'relative');
				}
			});

			if(!isLoaded && isVisible){
				animateTimeline(component);
			}

			const lastChild = component.querySelector('.timeline').lastElementChild;

			var dividerLoaded = false;
			if(!dividerLoaded){
				setTimeout(() => {
					divider.style.height = isMobile ? ((component.clientHeight - lastChild.clientHeight) - 10) + 'px' : '1px';					
					component.style.opacity = 1;
					divider.style.opacity = 1;
					dividerLoaded = true;
				},500);
			}
		});
	}

	function animateTimeline(component){
		const timeline = component.querySelector('.timeline');
		const compRect = component.getBoundingClientRect();
		const activeCards = component.querySelectorAll('.hasContent');
		const highlight = component.querySelector('.marker_highlight');
		const isLoaded = component.dataset.isLoaded;
		const activeCard = component.querySelector('.timeline__card.hasContent.active .timeline__marker');		

		if(activeCard){
			highlight.style.transition = 'none';
			if(isMobile){
				highlight.style.top = activeCard.getBoundingClientRect().top;
			}
			if(!isMobile){
				highlight.style.left = activeCard.getBoundingClientRect().left;
			}
			highlight.style.transition = 'all 1s ease'; 
		}
		if(!isLoaded){ 
			highlight.style.opacity = 1; 
		}
		timeline.classList.add('isAnimating');

		const tl = gsap.timeline();
		activeCards.forEach((card, index) => {
			tl.to(card, { 
				duration: 0.1, 
				delay: index * 1, 
				onComplete: () => {
					const marker = card.querySelector('.timeline__marker');
					const markerRect = marker.getBoundingClientRect();
					const xPosition = markerRect.left - compRect.left;
					const yPosition = getAbsoluteYPosition(marker) - getAbsoluteYPosition(component); 

					if(isMobile){
						highlight.style.setProperty('top', (yPosition - 20) + 'px');
					}else{
						highlight.style.left = xPosition + 'px';
					}
					
					if(index > 0){
						activeCards[index - 1].classList.remove("hasContent");
					}
				}
			})
			.to(card, {
				duration: 0.1,
				delay: 1,
				onComplete: () => { 
					card.classList.add("active");

					if(!isMobile){
						const content = card.querySelector('.timeline__content');
						const rte = card.querySelector('.rte');
						content.style.position = 'absolute';
						content.style.pointerEvents = 'none';
						rte.style.pointerEvents = 'auto';
						rte.position = 'absolute';
						rte.zIndex = '19';
					}
				}
			}, "<"); 
		});
		
		// After ALL animations, set opacity to 0
		tl.to(highlight, {
			opacity: 0,
			duration: 0.1,
			delay: 0.5,
			onComplete: () => {
				timeline.classList.remove("isAnimating");
				component.setAttribute('isLoaded', true);
			}
		});
	}

	function getAbsoluteYPosition(element) {
		let yPos = 0;
		while (element) {
			yPos += element.offsetTop;
			element = element.offsetParent;
		}
		return yPos;
	}

	function clampCenteredContent(container, content) {
		const containerRect = container.getBoundingClientRect();
		const contentRect = content.getBoundingClientRect();
		
		const isOutsideLeft = contentRect.left < containerRect.left;
		const isOutsideRight = contentRect.right > containerRect.right;

		if (!isOutsideLeft && !isOutsideRight) return;

		var adjustX = 0;

		if (isOutsideLeft) {
			adjustX = containerRect.left - contentRect.left;
		} else if (isOutsideRight) {
			adjustX = containerRect.right - contentRect.right;
		}

		const transform = window.getComputedStyle(content).transform;
		const matrix = new DOMMatrix(transform);
		
		const newTranslateX = matrix.m41 + adjustX;
		content.style.transform = 'translateX(' + newTranslateX + 'px)';
	}

	const isReallyResized = (() => {
		let prev = { width: window.innerWidth, height: window.innerHeight };

		return () => {
			const curr = { width: window.innerWidth, height: window.innerHeight };

			const heightDiff = Math.abs(curr.height - prev.height);
			const widthDiff = Math.abs(curr.width - prev.width);

			const heightRatio = heightDiff / prev.height;
			const widthRatio = widthDiff / prev.width;

			const drasticChange =
			heightRatio > 0.5 || widthRatio > 0.5 || // at least 50% change
			(curr.width > curr.height && prev.width < prev.height) || // landscape ↔ portrait
			(curr.width < curr.height && prev.width > prev.height);

			prev = curr;
			return drasticChange;
		};
	})();

	var resizeTimeout;
	function handleResize() {
		clearTimeout(resizeTimeout);

		isMobile = window.innerWidth < 992; 
		resizeTimeout = setTimeout(() => {	
			const didOrientationChange = isReallyResized();
			if(!didOrientationChange) return;

			components.forEach(component => {				
				const total_width = component.clientWidth;
				const divider = component.querySelector('.timeline__divider');
				const timelinecards = component.querySelectorAll('.timeline__card');

				if(timelinecards && timelinecards.length){
					setTimelineCards(component, total_width, divider, timelinecards);
				}
			});
		}, 250);
	}

	window.addEventListener('resize', handleResize);
});